import {
  SIMPLE_CHAT_ADD_MESSAGE,
  SIMPLE_CHAT_RESET,
  LOGOUT,
  RESET_STATE
} from "../constants/action-types";

interface ChatMessage {
  userResponse: string;
  aiResponse: string;
  isLiked: boolean;
  isDisliked: boolean;
  uniqueId: string;
}

interface SimpleChatState {
  messages: ChatMessage[];
}

const initialState: SimpleChatState = {
  messages: []
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case SIMPLE_CHAT_ADD_MESSAGE: {
      const { userResponse, aiResponse, isLiked, isDisliked, uniqueId } = action;

      // Check if we're updating an existing message (by uniqueId)
      const messageIndex = state.messages.findIndex(
        (message: ChatMessage) => message.uniqueId === uniqueId
      );

      let updatedMessages;
      if (messageIndex !== -1) {
        // Update existing message
        updatedMessages = state.messages.map(
          (message: ChatMessage, index: number) =>
            index === messageIndex
              ? {
                  ...message,
                  userResponse: userResponse !== undefined ? userResponse : message.userResponse,
                  aiResponse: aiResponse !== undefined ? aiResponse : message.aiResponse,
                  isLiked: isLiked !== undefined ? isLiked : message.isLiked,
                  isDisliked: isDisliked !== undefined ? isDisliked : message.isDisliked,
                }
              : message
        );
      } else {
        // Add new message
        updatedMessages = [
          ...state.messages,
          {
            userResponse: userResponse || "",
            aiResponse: aiResponse || "",
            isLiked: isLiked || false,
            isDisliked: isDisliked || false,
            uniqueId
          }
        ];
      }

      return {
        ...state,
        messages: updatedMessages
      };
    }

    case SIMPLE_CHAT_RESET:
    case LOGOUT:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
}; 